<div class="trailerDiv" fxLayout="row wrap">

    <div fxLayoutAlign="center center" class="video">
        <iframe [src]="videoUrl" class="iframeTrailer" width="800" height="400" 
            frameborder="0" allow="autoplay; fullscreen; picture-in-picture" webkitallowfullscreen
            mozallowfullscreen allowfullscreen></iframe>
    </div>

</div>

